import { useState, useEffect } from 'react';
import { getDemographicsCountryFilters } from '@/pages/intelligence/services/filter';
import { validateDemographicsSource } from '@/pages/intelligence/utils/validateDemographicsSource';

export default function useDemographicsRegionsOptions(props: any) {
  const {
    appIds = [],
    source,
    granularity,
    waitForParams = false,
    refreshKey = 0,
    getCountriesFilterFun = getDemographicsCountryFilters
  } = props || {};
  const [marketLoading, setMarketLoading] = useState(true);
  const [allMarkets, setAllMarkets] = useState<string[]>([]);

  const [regionOptions, setRegionOptions] = useState<any[]>([]);

  const updateRegionsOptionsMap = async () => {
    try {
      setMarketLoading(true);
      const payload: any = { app_ids: appIds };
      if (source) {
        payload.source = validateDemographicsSource(source);
      }
      if (granularity) payload.granularity = granularity;
      const res = await getCountriesFilterFun?.(payload);
      const regionsCountries = res?.data;
      if (!Array.isArray(regionsCountries)) {
        // setRegionsOptionsMap({});
        return;
      }
      // let regionsOptions = [];
      let markets: string[] = [];
      regionsCountries.forEach((item: any) => {
        item?.country_set?.forEach((t: any) => {
          markets.push(t?.country_code);
        });
        // regionsOptions.push(item);
      });
      setAllMarkets(markets);
      setRegionOptions(regionsCountries);
    } catch (err) {
      setAllMarkets([]);
      setRegionOptions([]);
    } finally {
      setMarketLoading(false);
    }
  };

  useEffect(() => {
    // if (!executable) return;
    if (waitForParams && (!source || !granularity)) {
      setMarketLoading(false);
      return;
    }
    updateRegionsOptionsMap();
  }, [JSON.stringify(appIds), source, granularity, waitForParams, refreshKey]);

  return {
    marketLoading,
    regionOptions,
    allMarkets,
    // regionsOptionsMap,
  };
}
